<template>
    <div class="row justify-content-center align-items-center bg-danger text-light" style="background-color: #2f519a;">
        <div class="col-11 col-sm-8">
            <Question v-for="question of questions" :key="question.id" :question="question" :answers="getAnswers" />
            <br>
            <button v-if="number < pages" class="btn btn-primary btn-block" @click="changePage">Continuar</button>
            <button v-else class="btn btn-primary btn-block" @click="annexPage">Continuar</button>
        </div>
    </div>
</template>

<script>
import Question from "@/components/Question";
import router from "../router";
import { Decimal } from "decimal.js";
import { mapGetters } from "vuex";

export default {
    props: ["number"],
    computed: {
        questions() {
            return this.getEvaluation.questions[this.number];
        },
        pages() {
            return parseInt(this.getEvaluation.pages) - 1;
        },
        ...mapGetters(["getAnswers", "getEvaluation", "getUser"]),
    },
    methods: {
        changePage() {
            let canSave = true;
            this.questions.forEach((question) => {
                let res = this.getAnswers.find((ans) => {
                    return ans.question == question.id;
                });

                if (!res) {
                    canSave = false;
                }
            });

            if (!canSave) {
                alert(
                    "Todas las preguntas son requeridas para poder continuar"
                );

                return false;
            }

            router.push({
                name: "Questions",
                params: { number: parseInt(this.number) + 1 },
            });
        },
        annexPage() {
            let total_questions = new Decimal(
                this.getEvaluation.question_count
            );

            let total_answers = new Decimal(this.getAnswers.length);

            if (!total_questions.eq(total_answers)) {
                alert(
                    "Es necesario contestar todas las preguntas para poder calcular los resultados"
                );
                return false;
            }

            router.push({
                name: "Annexes",
            });
        },
    },
    components: {
        Question,
    },
};
</script>

<style>
</style>
